import React from 'react';
import styled from 'styled-components';

const Icon = ({ icon, className }) => <i className={className}>{icon}</i>;

export default styled(Icon)`
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 20px; /* Preferred icon size */
    width: 20px;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;

    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;

    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;

    /* Support for IE. */
    font-feature-settings: 'liga';
`;



// WEBPACK FOOTER //
// ./src/uic/FontIcon.js